import React from "react";
import type { OrderSummaryProps } from "./types";

// Format price helper - always show integers
const formatPrice = (value: number) => Math.round(value).toString();

export const OrderSummary: React.FC<OrderSummaryProps> = ({
  side,
  quantity,
  price,
  teamCode,
  teamPredictedPoints,
}) => {
  const displayPrice = formatPrice(price);
  const picksValueDisplay =
    teamPredictedPoints == null || Number.isNaN(teamPredictedPoints)
      ? "—"
      : Number.isInteger(teamPredictedPoints)
        ? `${teamPredictedPoints}`
        : teamPredictedPoints.toFixed(1).replace(/\.0$/, "");

  return (
    <div className="rounded-2xl border border-border bg-background-card px-4 py-3">
      <div className="font-display text-[24px] font-bold uppercase text-foreground">
        {side} {quantity ?? 0} {teamCode} @{displayPrice}
      </div>
      <div className="mt-1 font-mono text-sm text-foreground-muted md:text-base">My Pick Value: {picksValueDisplay}</div>
    </div>
  );
};
